import React from "react";
import {
  Image,
  ImageBackground,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  AvatarModalPng,
  InviteBckd,
  InvitePlus,
  ProfileScore,
} from "../../../../assets";
import { useDispatch, useSelector } from "react-redux";
import { facebookInvite } from "../../../../services/invite/facebookInvite";

import { isPortrait } from "../../../../utils/common";
import {
  inviteFriendsFailure,
  inviteFriendsRequest,
  inviteFriendsSuccess,
} from "../../../../store/invites/inviteActions";
import { toast } from "../../../../utils/helpers/toastUtils";
// import {
//   fbUiAppRequest,
//   loadFacebookSDK,
// } from "../../../../utils/helpers/facebookWeb";
import { useDevice } from "../../../../utils/hooks/useDevice";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../../store";

// const FACEBOOK_APP_ID =
//   process.env.NEXT_PUBLIC_FACEBOOK_APP_ID ||
//   process.env.REACT_APP_FACEBOOK_APP_ID ||
//   "125236521496270";

const InviteNewPlayerCard = () => {
  // async function inviteNative({
  //   message,
  //   url,
  // }: {
  //   message: string;
  //   url: string;
  // }) {
  //   const shareMessage = Platform.OS === "ios" ? message : `${message}\n${url}`;

  //   await Share.open({
  //     title: "Invite to Svara",
  //     message: shareMessage,
  //     url,
  //   });
  // }

  const myUserId = useSelector((state: RootState) => state.auth.user?.id);
  const mkTrace = () => `invite_${Date.now()}`;

  const log = (traceId: string, step: string, data?: any) => {
    if (data !== undefined) {
      console.log(`📩 [INVITE][${traceId}] ${step}`, data);
    } else {
      console.log(`📩 [INVITE][${traceId}] ${step}`);
    }
  };

  const logErr = (traceId: string, step: string, e: any) => {
    console.error(`❌ [INVITE][${traceId}] ${step}`, {
      message: e?.message,
      code: e?.code,
      stack: e?.stack,
      raw: String(e),
    });
  };

  const handleInvite = async () => {
    const traceId = mkTrace();
    log(traceId, "CLICK", { platform: Platform.OS, myUserId });

    if (!myUserId) {
      log(traceId, "ABORT: missing myUserId");
      toast.error("Invite failed", "No user id. You are not logged in?");
      return;
    }

    const url = `https://svara.app/invite?ref=${myUserId}`;
    log(traceId, "Invite URL built", { url });

    try {
      const res = await facebookInvite(url);
      log(traceId, "SUCCESS: invite shared", res);
      toast.success("Shared", "Invite opened");
    } catch (e: any) {
      logErr(traceId, "Invite failed", e);
      toast.error("Invite failed", e?.message || "Try again later");
    }
  };

  const dispatch = useDispatch();

  // const handleInvite = async () => {
  // if (Platform.OS === "web") {
  //   try {
  //     await loadFacebookSDK(FACEBOOK_APP_ID);
  //     const res: any = await fbUiAppRequest({
  //       app_id: FACEBOOK_APP_ID,
  //       method: "apprequests",
  //       message: "Join me in Svara! Let’s play ",
  //       display: "popup",
  //       mobile_iframe: true,
  //     });

  //     const ids = Array.isArray(res?.to) ? res.to : [];
  //     dispatch(inviteFriendsSuccess({ recipientIds: ids }));
  //     toast.success(
  //       "Invitations sent",
  //       ids.length
  //         ? `${ids.length} friend(s) invited`
  //         : "Sent without recipients"
  //     );
  //   } catch (e: any) {
  //     dispatch(inviteFriendsFailure(e?.message || "Facebook invite failed"));
  //     toast.error("Facebook invite failed", e?.message || "Try again later");
  //   }
  //   return;
  // }

  // Native path
  //   dispatch(
  //     inviteFriendsRequest({ message: "Join me in Svara! Let’s play " }),
  //   );
  // };
  const { isMobile } = useDevice();
  const { t } = useTranslation();

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={handleInvite}
      style={{ borderRadius: 12 }}
    >
      <ImageBackground
        source={InviteBckd}
        resizeMode="contain"
        style={[
          styles.cardBackground,
          {
            paddingRight: isMobile ? 12 : 0,
          },
        ]}
      >
        <View
          style={[
            styles.container,
            {
              gap: isMobile ? 8 : 12,
              marginLeft: isMobile ? 8 : 6,
              marginRight: 14,
            },
          ]}
        >
          <View
            style={[
              styles.avatarWrapper,
              {
                width: isMobile ? 110 : 120,
                marginLeft: isMobile ? -36 : -10,
              },
            ]}
          >
            <ImageBackground
              source={AvatarModalPng}
              style={{
                width: isMobile ? 76 : 130,
                height: isMobile ? 60 : 100,
                position: "relative",
                left: isMobile ? -14 : -24,
              }}
              resizeMode="contain"
            />
            <Image
              source={ProfileScore}
              style={[
                styles.scoreBadge,
                {
                  width: isMobile ? 32 : 38,
                  height: isMobile ? 32 : 38,
                  top: isMobile ? 16 : 30,
                  left: isMobile ? 54 : 60,
                },
              ]}
              resizeMode="contain"
            />
            <Text
              style={[
                styles.scoreText,
                {
                  top: isMobile ? 26 : 36,
                  left: isMobile ? 86 : 98,
                  fontSize: isMobile ? 14 : 18,
                },
              ]}
            ></Text>
          </View>

          <View style={[styles.statsItem, { marginRight: isMobile ? 0 : 20 }]}>
            <Text
              style={[
                styles.nameText,
                {
                  fontSize: isMobile ? 14 : 20,
                },
              ]}
            >
              {/* Invite player */}
              {t("T_SITE_MODAL_INVITATION_INVITE")}
              {/* Invite Player */}
            </Text>
            <View style={{ width: 50, height: 40 }}>
              <Image
                source={InvitePlus}
                resizeMode="contain"
                style={styles.plusIcon}
              />
            </View>
          </View>
        </View>
      </ImageBackground>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  cardBackground: {
    borderRadius: 12,
    marginBottom: 2,
    marginLeft: 16,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  avatarWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  scoreBadge: {
    position: "absolute",
  },
  scoreText: {
    width: 38,
    height: 38,
    position: "absolute",
    color: "#fff",
    fontWeight: "600",
  },
  nameText: {
    flex: 1,
    color: "white",
    fontWeight: "500",
    marginLeft: 3,
    textTransform: "uppercase",
  },
  statsItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  plusIcon: {
    width: 48,
    height: 48,
  },
});

export default InviteNewPlayerCard;
